import { render } from "./presentacion.vue?vue&type=template&id=ec6930f0&scoped=true"
import script from "./presentacion.vue?vue&type=script&lang=js"
export * from "./presentacion.vue?vue&type=script&lang=js"

import "./presentacion.vue?vue&type=style&index=0&id=ec6930f0&scoped=true&lang=css"

import exportComponent from "/home/raulgarcia/Escritorio/projects/Vue/capwashmx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec6930f0"]])

export default __exports__